import { cn } from '@utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const variantStyles = cva(
  cn(
    'group inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'rounded-md text-sm font-medium transition-colors cursor-pointer',
    'ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    "border disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
  ),
  {
    variants: {
      variant: {
        primary: cn(
          'border-primary bg-primary text-primary-foreground hover:bg-primary/90',
        ),
        destructive:
          'border-destructive bg-destructive text-destructive-foreground hover:bg-destructive/90',
        secondary:
          'border-secondary bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground',
        outline: cn(
          'border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground',
        ),
        link: 'border-transparent text-primary underline-offset-4 hover:underline',
        ghost:
          'border-transparent hover:bg-accent hover:text-accent-foreground',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);

export { variantStyles };

export type VariantKey = VariantProps<typeof variantStyles>['variant'];
